



























































import {Component, Emit, PropSync} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import moment from 'moment';
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {PickingListReTransportStore} from "@/modules/pickinglistretransport/store";
import {PickingListReTransport} from "@/interfaces/entity/pickinglistretransport";
import PLReTransportStatusLabel
    from "@/modules/pickinglistretransport/shared/component/PickingListReTransportStatusLabel/index.vue";
import {PickingListReTransportType} from "@/enums/type";
import {PickingListDelivery} from "@/interfaces/entity";
import {PickingListDeliveryStatus} from "@/enums/status";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "PLReTransportTable",
    components: {TooltipLabel, PLReTransportStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @PropSync("dataSource", {required: true}) syncDataSource!: Array<PickingListReTransport>;
    moment = moment;
    PickingListReTransportType = PickingListReTransportType;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 100,
        },
        {
            title: "Mã xuất kho",
            dataIndex: "code",
            key: "code",
            width: 130,
            ellipsis: true,
            scopedSlots: {customRender: "code"}
        },
        {
            title: "Ngày, giờ phân công",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdDate"}
        },
        {
            title: "Khách hàng",
            dataIndex: "customer.fullName",
            key: "customer.rowGuid",
            scopedSlots: {customRender: "customerCode"},
            width: 250,
            ellipsis: true
        },
        {
            title: "Tổng đơn",
            dataIndex: "ladingQuantity",
            key: "ladingQuantity",
            width: 100
        },
        {
            title: "Thu hộ ( COD )",
            dataIndex: "receiverCollect",
            key: "receiverCollect",
            scopedSlots: {customRender: "receiverCollect"},
            width: 120
        },
        {
            title: "Tuyến phát",
            dataIndex: "targetRowGuid",
            key: "targetRowGuid",
            scopedSlots: {customRender: "target"},
            width: 180,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        }];

    get pagination(): object {
        return {
            current: PickingListReTransportStore.meta?.page,
            pageSize: PickingListReTransportStore.meta?.limit,
            total: PickingListReTransportStore.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} bảng kê`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    @Emit("onChangePage")
    onChangePage(pagination: any) {
        return pagination;
    }

    @Emit("see-detail")
    seeDetail(id: number) {
        return id;
    }

    @Emit('delete')
    deletePickingListReTransport(id: number) {
        return id;
    }

    canDeletePickingListReTransport(pickingList: PickingListReTransport): boolean {
        if (pickingList.type === PickingListReTransportType.Employee && pickingList.status === PickingListDeliveryStatus.WaitingConfirm)
            return true;
        else if (pickingList.type === PickingListReTransportType.Partner)
            return true;
        else
            return false;
    }
}
